export const miscBandsProductsData = [
  {
    productName: "Pair Arm Bands + Pump",
    images: ["pair-arm-main.png"],
    details: ["B3 Band Single Pair (2 Bands) + Pump"],
    skuConfigurations: [
      {
        Sku: "RCPrSet1",
        Size: "B3 Band Size 1",
        attachedSku: "Bands1",
      },
      {
        Sku: "RCPrSet2",
        Size: "B3 Band Size 2",
        attachedSku: "Bands2",
      },
    ],
    allowAdditionalItem: true,
    sizeSelection: true,
    quantitySelection: false,
  },
  {
    productName: "Pair Leg Bands + Pump",
    images: ["pair-leg-main.png"],
    details: ["B3 Band Single Pair (2 Bands) + Pump"],
    skuConfigurations: [
      {
        Sku: "RCPrSet3",
        Size: "B3 Band Size 3",
        attachedSku: "Bands3",
      },
      {
        Sku: "RCPrSet4",
        Size: "B3 Band Size 4",
        attachedSku: "Bands4",
      },
      {
        Sku: "RCPrSet5",
        Size: "B3 Band Size 5",
        attachedSku: "Bands5",
        Additional: 30,
      },
    ],
    allowAdditionalItem: true,
    sizeSelection: true,
    quantitySelection: false,
  },
  {
    productName: "Single Arm Band",
    images: ["single-arm-main.png"],
    details: ["B3 Band Single Arm"],
    skuConfigurations: [
      {
        Sku: "RCSize1",
        Size: "B3 Band Size 1",
      },
      {
        Sku: "RCSize2",
        Size: "B3 Band Size 2",
      },
    ],
    allowAdditionalItem: false,
    sizeSelection: true,
    quantitySelection: true,
  },
  {
    productName: "Single Leg Band",
    images: ["single-leg-main.png"],
    details: ["B3 Band Single Leg"],
    skuConfigurations: [
      {
        Sku: "RCSize3",
        Size: "B3 Band Size 3",
      },
      {
        Sku: "RCSize4",
        Size: "B3 Band Size 4",
      },
      {
        Sku: "RCSize5b",
        Size: "B3 Band Size 5",
        Additional: 30,
      },
    ],
    allowAdditionalItem: false,
    sizeSelection: true,
    quantitySelection: true,
  },
  {
    productName: "Pump",
    images: ["pump-main.png"],
    details: ["B3 Bands Pump"],
    addToCartSku: "Pump",
    sizeSelection: false,
    allowAdditionalItem: false,
    quantitySelection: false,
  },
];
